import Vue from 'vue';
import Vuex from 'vuex';

/* dictionaries */
import dictionaries from '@/store/dictionaries';

/* modules */
import activityLog                    from '@/store/modules/activityLog';
import analytics                      from '@/store/modules/analytics';
import auth                           from '@/store/modules/auth';
import banners                        from '@/store/modules/banners';
import currentUser                    from '@/store/modules/currentUser';
import currentUserModulesRestrictions from '@/store/modules/currentUserModulesRestrictions';
import currentUserPrivileges          from '@/store/modules/currentUserPrivileges';
import emailTemplates                 from '@/store/modules/emailTemplates';
import partner    	                  from '@/store/modules/partner';
import offer                          from '@/store/modules/offer';
import payouts                        from '@/store/modules/payouts';
import password                       from '@/store/modules/password';
import proxies                        from '@/store/modules/proxies';
import triggers                       from '@/store/modules/triggers';
import messages                       from '@/store/modules/messages';
import users                          from '@/store/modules/users';
import externalIntegrations           from '@/store/modules/externalIntegrations';
import filters                        from '@/store/modules/filters';

/* tags*/
import tags         from '@/store/modules/tags';

Vue.use(Vuex);

// TODO remove environment logic, move to env config;
const debug = !['production', 'test'].includes(process.env.NODE_ENV);

const storeConfig = {
    modules: {
        dictionaries,
        activityLog,
        auth,
        banners,
        users,
        partner,
        payouts,
        proxies,
        offer,
        analytics,
        currentUser,
        currentUserModulesRestrictions,
        currentUserPrivileges,
        tags,
        triggers,
        messages,
        password,
        emailTemplates,
        externalIntegrations,
        filters,
    },
    strict: debug,
};

export default new Vuex.Store(storeConfig);

export { storeConfig };
